import { QueryKey } from '@tanstack/react-query'
import { Id, toast } from 'react-toastify'
import { queryClient } from '../'
import { PageListParams } from './globalTypes'

export const invalidateQueries = (keys: unknown[]) => {
    return queryClient.invalidateQueries({
        queryKey: keys,
    })
}

export const getQueryData = <T>(baseKeys: QueryKey, params?: PageListParams): T | undefined => {
    const finalKeys = [...baseKeys]

    if (params) {
        finalKeys.push(params)
    }

    return queryClient.getQueryData<T>(finalKeys)
}

export const setQueryData = <T>(baseKeys: QueryKey, data: T, params?: PageListParams): void => {
    const finalKeys = [...baseKeys]

    if (params) {
        finalKeys.push(params)
    }

    queryClient.setQueryData(finalKeys, data)
}

export const updateToast = (toastId: Id, message: string, type: 'success' | 'error') => {
    toast.update(toastId, {
        render: message,
        type: type,
        isLoading: false,
        autoClose: 3000,
    })
}

// TODO: not really needed for table invalidation, should be renamed to something like invalidateMatchingQueries
export const invalidateQueryInTable = (keyToInvalidate: string) => {
    queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes(keyToInvalidate),
    })
}

